import { AfterContentInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';

import { NotificationService } from '../../../../core/services';
import { jsTagTypes } from '../../../../core/constants';
import { NotificationComponent } from '../../../../shared/components';

import { MacrosListComponent } from '../macros-list';

@Component({
  selector: 'app-generated-js-tag',
  templateUrl: './generated-js-tag.component.html',
  styleUrls: ['./generated-js-tag.component.scss'],
  standalone: false
})
export class GeneratedJsTagComponent implements AfterContentInit {

  @Input() public set tagType(value: string) {
    this._tagType = value;
  }

  public get tagType(): string {
    return this._tagType;
  }

  @Input() public set jsTag(value: string) {
    this._jsTag = value;
  }

  public get jsTag(): string {
    return this._jsTag;
  }

  @Input() public set macrosListJs(value: any[]) {
    this._macrosListJs = value;
  }

  public get macrosListJs(): any[] {
    return this._macrosListJs;
  }

  @Input() public set selectedMacros(value: string[]) {
    this._selectedMacros = value;
  }

  public get selectedMacros(): string[] {
    return this._selectedMacros;
  }

  @Output() public changedJsTag = new EventEmitter<string[]>();
  @Output() public changedJsTagType = new EventEmitter<string>();

  protected jsTagTypes = jsTagTypes;
  private macrosListContentHeight = 'auto';
  private macrosListBodyHeight = 'auto';

  private _tagType: string;
  private _jsTag: string;
  private _macrosListJs: any[];
  private _selectedMacros: string[];

  constructor(
    private modalService: NzModalService,
    private notificationService: NotificationService,
    private notificationComponent: NotificationComponent,
  ) { }

  public ngAfterContentInit(): void {
    this.macrosListContentHeight = window.innerHeight - 200 + 'px';
    this.macrosListBodyHeight = window.innerHeight - 250 + 'px';
    window.addEventListener('resize', () => {
      this.macrosListContentHeight = window.innerHeight - 200 + 'px';
      this.macrosListBodyHeight = window.innerHeight - 250 + 'px';
    });
  }

  protected linkCopy(): void {
    this.showNotification('JS Tag Copied');
  }


  protected onTagTypeChanged(type: string): void {
    this.changedJsTagType.emit(type);
  }

  protected showMacrosList(): void {
    this.modalService.create({
      nzContent: MacrosListComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzClassName: 'macros-list-modal',
      nzWrapClassName: 'macros-list-modal-wrap',
      nzStyle: { top: '30px', width: '650px', height: this.macrosListContentHeight },
      nzBodyStyle: { width: '650px', padding: '0px', height: this.macrosListBodyHeight, overflowY: 'scroll' },
      nzData: {
        macrosList: this.macrosListJs,
      }
    });
  }

  protected changeMacros(selectedItems: string[]): void {
    this.changedJsTag.emit(selectedItems);
  }

  private showNotification(description: string): void {
    const data = {
      iconType: 'info',
      color: 'info',
      notificationType: 'info',
      description,
    };

    this.notificationComponent.data = data;
    this.notificationService.showTemplate({ nzData: data, nzStyle: { width: '300px' } });
  }

}
